/** Resolves the option index a navigation key moves to, or undefined for keys that don't move the selection. */
export function getNextOptionIndex(key: string, currentIndex: number, optionCount: number): number | undefined {
  switch (key) {
    case 'ArrowDown':
      return currentIndex < 0 ? 0 : (currentIndex + 1) % optionCount;
    case 'ArrowUp':
      return currentIndex < 0 ? optionCount - 1 : (currentIndex - 1 + optionCount) % optionCount;
    case 'Home':
      return 0;
    case 'End':
      return optionCount - 1;
    default:
      return undefined;
  }
}
